import lazyframe from "lazyframe";

function pauseYoutubeVideo(obj) {
    let command = {
        "event": "command",
        "func": "pauseVideo"
    };
    obj.contentWindow.postMessage(JSON.stringify(command), '*');
}

function playYoutubeVideo(obj) {
    let command = {
        "event": "command",
        "func": "playVideo"
    };
    obj.contentWindow.postMessage(JSON.stringify(command), '*');
}
function pauseVimeoVideo(obj) {
    let command = {
        "method": "pause",
        "value": 1
    };
    obj.contentWindow.postMessage(JSON.stringify(command), '*');
}

function playVimeoVideo(obj) {
    let command = {
        "method": "play",
        "value" : 1
    };
    obj.contentWindow.postMessage(JSON.stringify(command), '*');
}
export function pauseSliderVideos (slider) {
    let slides = slider.el.querySelectorAll('.swiper-slide');
    for (let s in slides) {
        if(isNaN(s)) continue;
        if(slides[s].querySelector('video') !== null) slides[s].querySelector('video').pause();
        else if(slides[s].querySelector('iframe.yt-player') !== null) pauseYoutubeVideo(slides[s].querySelector('iframe.yt-player'));
        else if(slides[s].querySelector('iframe.vi-player') !== null) pauseVimeoVideo(slides[s].querySelector('iframe.vi-player'));
    }
}

export function playSliderVideos(slider) {
    let activeSlide = slider.el.querySelectorAll('.swiper-slide')[slider.activeIndex];
    if(activeSlide.querySelector('video') !== null) activeSlide.querySelector('video').play();
    else if(activeSlide.querySelector('iframe.yt-player') !== null) playYoutubeVideo(activeSlide.querySelector('iframe.yt-player'));
    else if(activeSlide.querySelector('iframe.vi-player') !== null) playVimeoVideo(activeSlide.querySelector('iframe.vi-player'));
}